import { graphql } from "@/gql";

export const createSignedMediaUploadUrl = graphql(`
  mutation CreateSignedStorageUrl($input: SignedStorageUrlInput!) {
    createSignedStorageUrl(input: $input) {
      filePath
      headers
      url
    }
  }
`);

export const createMediaMutation = graphql(`
  mutation CreateMedia($input: CreateMediaInput!) {
    createMedia(input: $input) {
      id
      url
    }
  }
`);

export const updateMediaMutation = graphql(`
  mutation UpdateMedia($id: ID!, $input: UpdateMediaInput!) {
    updateMedia(id: $id, input: $input) {
      id
      alt
    }
  }
`);

export const deleteMediaMutation = graphql(`
  mutation DeleteMedia($id: ID!) {
    deleteMedia(id: $id) {
      id
    }
  }
`);

export const mediaSetNewOrderMutation = graphql(`
  mutation MediaSetNewOrder($ids: [ID!]!) {
    mediaSetNewOrder(ids: $ids)
  }
`);
